import { Divider, Form, Row, Space, Table } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { columns, columnsTableMenu, fields, fields2 } from "./config";
import { InputFields } from "components/common";
import Icons from "assets/icons";

const NurseOutInfo = ({ data }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(data?.ketLuanDto);
  }, [data]);

  return (
    <Fragment>
      <div style={{ fontWeight: "700", fontSize: "15px" }}>Chẩn đoán (ICD)</div>
      <Table
        columns={columns}
        dataSource={data?.ketLuanDto?.chiTietKetLuans || []}
        bordered
        scroll={{ x: "100%", y: 300 }}
        pagination={false}
      />
      <Divider />
      <div style={{ fontWeight: "700", fontSize: "15px " }}>Bệnh phụ</div>
      <Table
        columns={columns}
        dataSource={data?.ketLuanDto?.chiTietBenhPhuDtos || []}
        bordered
        scroll={{ x: "100%", y: 300 }}
        pagination={false}
      />
      <Form form={form}>
        <Row gutter={[16, 16]} style={{ paddingTop: "10px" }}>
          <InputFields data={fields} />
        </Row>
        <Divider />
        {/* <div className="title">Kết luận và hẹn tái khám</div> */}
        <Row gutter={[16, 16]}>
          <InputFields data={fields2} />
        </Row>
      </Form>
    </Fragment>
  );
};

export default NurseOutInfo;
